// client/src/components/SectionInfoBox.tsx
import React, { useState } from 'react';

interface SectionInfoBoxProps {
    text?: string;
    className?: string;
    align?: 'left' | 'right' | 'center';
}

const SectionInfoBox: React.FC<SectionInfoBoxProps> = ({ text, className = "", align = "left" }) => {
    const [show, setShow] = useState(false);

    const displayText = text?.trim() || '';
    const hasContent = displayText.length > 0;

    if (!hasContent) return null;

    let tooltipPosition = "left-0";
    let arrowPosition = "left-[4px]";

    if (align === 'right') {
        tooltipPosition = "right-0";
        arrowPosition = "right-[4px]";
    } else if (align === 'center') {
        tooltipPosition = "left-1/2 -translate-x-1/2";
        arrowPosition = "left-1/2 -translate-x-1/2";
    }

    return (
        <div className={`relative inline-block ml-2 group ${className}`}>
            <div 
                className="w-5 h-5 rounded-full flex items-center justify-center cursor-help transition-all shadow-sm hover:shadow-md bg-blue-600 hover:bg-blue-700"
                onMouseEnter={() => setShow(true)}
                onMouseLeave={() => setShow(false)}
            >
                <i className="fa-solid fa-info text-[10px] text-white"></i>
            </div>
            
            {show && (
                <div className={`absolute top-[calc(100%+8px)] ${tooltipPosition} w-max max-w-[280px] sm:max-w-[350px] p-3 bg-white border border-slate-200 rounded-xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.3)] z-[999] animate__animated animate__fadeIn animate__faster`}>
                    <div className="text-[12px] font-bold leading-relaxed text-black whitespace-pre-wrap text-left">
                        {displayText}
                    </div>
                    {/* Tooltip Arrow (pointing up) */}
                    <div className={`absolute bottom-full ${arrowPosition} border-[6px] border-transparent border-b-white drop-shadow-sm`}></div>
                </div>
            )}
        </div>
    );
};

export default SectionInfoBox;
